import { render, staticRenderFns } from "./StatusCell.vue?vue&type=template&id=b804a6c8&scoped=true&"
import script from "./StatusCell.vue?vue&type=script&lang=ts&"
export * from "./StatusCell.vue?vue&type=script&lang=ts&"
import style0 from "./StatusCell.vue?vue&type=style&index=0&id=b804a6c8&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b804a6c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
